export const environment = {
  production: true,
  apiUrl: 'https://api.mapavyuky.cz',
};
